import * as React from "react";

import ToastComponent from "./ToastComponent";

import "./styles.scss";

const ToastContext = React.createContext();

const ToastContextComponent = ({ children }) => {
  const [toasts, setIsToasts] = React.useState([]);

  const removeToast = (id) => {
    setIsToasts((prev) => prev.filter((t) => t.id !== id));
  };

  const addToast = (t) => {
    const id = t.id || Math.floor(Math.random() * 1000);

    setIsToasts((prev) => {
      if (!prev.find((ot) => ot.id === id)) {
        return [...prev, { ...t, id }];
      }
      return prev;
    });

    if (!t.isDismissible || t.duration) {
      setTimeout(() => {
        removeToast(id);
      }, t.duration || 5000);
    }
  };

  return (
    <ToastContext.Provider
      value={{
        addToast,
      }}
    >
      {toasts && (
        <div id="AppToast">
          {toasts.map((t) => (
            <ToastComponent key={t.id} {...t} onClose={removeToast} />
          ))}
        </div>
      )}
      {children}
    </ToastContext.Provider>
  );
};

const useToast = () => {
  const { addToast } = React.useContext(ToastContext);

  return { addToast };
};

export { useToast, ToastContextComponent as ToastContext };
